(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["deferred-image"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('deferred-image')) {
    customElements.define('deferred-image', class extends HTMLElement {
      connectedCallback() {
        const template = this.querySelector('template');
        if (!template) return;

        const frame = this.parentElement;
        const hero = document.querySelector('.hero__images img[fetchpriority="high"]');
        const release = () => {
          if (!this.isConnected) return;
          this.cleanup();
          const image = template.content.querySelector('img');
          const show = () => {
            image.classList.remove('is-loading');
            frame.classList.remove('is-loading');
          };
          image.addEventListener('load', show, { once: true });
          image.addEventListener('error', show, { once: true });
          this.replaceWith(template.content);
          if (image.complete) show();
        };
        let observer;
        let timeout;
        this.cleanup = () => {
          observer?.disconnect();
          clearTimeout(timeout);
          hero?.removeEventListener('load', release);
          hero?.removeEventListener('error', release);
        };

        if (!hero || hero.complete || !('IntersectionObserver' in window)) {
          release();
          return;
        }

        hero.addEventListener('load', release, { once: true });
        hero.addEventListener('error', release, { once: true });
        observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) release();
        }, { rootMargin: '500px' });
        observer.observe(frame);
        timeout = setTimeout(release, 8000);
      }

      disconnectedCallback() {
        this.cleanup?.();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["deferred-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('deferred-reviews')) {
    customElements.define('deferred-reviews', class extends HTMLElement {
      connectedCallback() {
        this.start = this.start || this.observe.bind(this);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.start, { once: true });
        } else {
          this.start();
        }
      }

      observe() {
        if (!this.isConnected || this.observing) return;
        this.observing = true;
        this.template = this.querySelector('template');
        if (!this.template) return;
        this.reveal = this.reveal || this.load.bind(this);
        this.hero = document.querySelector('.hero__images img[fetchpriority="high"]');
        if (!this.hero || this.hero.complete || !('IntersectionObserver' in window)) {
          this.reveal();
          return;
        }
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.reveal();
        }, { rootMargin: '500px' });
        this.observer.observe(this);
        this.hero.addEventListener('load', this.reveal, { once: true });
        this.hero.addEventListener('error', this.reveal, { once: true });
        this.fallback = window.setTimeout(this.reveal, 8000);
      }

      load() {
        if (!this.isConnected || this.loaded || !this.template) return;
        this.loaded = true;
        this.cleanup();
        this.template.replaceWith(this.template.content.cloneNode(true));
        const widget = this.querySelector('[data-oke-carousel]');
        if (!widget) return;
        this.initializeWidget = () => {
          if (!this.isConnected || !window.okeWidgetApi?.initWidget) return;
          document.removeEventListener('oke-script-loaded', this.initializeWidget);
          window.okeWidgetApi.initWidget(widget);
        };
        if (window.okeWidgetApi?.initWidget) {
          this.initializeWidget();
        } else {
          document.addEventListener('oke-script-loaded', this.initializeWidget, { once: true });
        }
      }

      cleanup() {
        this.observer?.disconnect();
        window.clearTimeout(this.fallback);
        this.hero?.removeEventListener('load', this.reveal);
        this.hero?.removeEventListener('error', this.reveal);
      }

      disconnectedCallback() {
        this.cleanup();
        document.removeEventListener('DOMContentLoaded', this.start);
        if (this.initializeWidget) document.removeEventListener('oke-script-loaded', this.initializeWidget);
        this.observing = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
